import * as CheckoutArtistLink from './CheckoutArtistLink';
import { take } from "../util";
export const fromGql = (gqlItem) => (Object.assign(Object.assign({}, take(gqlItem, 'name')), { links: gqlItem.links ? CheckoutArtistLink.fromGqlCollection(gqlItem.links) : [] }));
export const fromGqlCollection = (gqlItems) => gqlItems.map(fromGql);
//# sourceMappingURL=CheckoutArtist.js.map